<script>
  import auth from "@store/auth"
</script>

{#if !$auth.merchant.has_active_subscription}
  <div class="bg-canvas/50 absolute inset-0 z-30" />
{/if}
